<template>
  <div class="recharge_left">
    <div class="rechargeheader">
      <el-card class="box-card common-bg" shadow="never">
        <div slot="header" class="clearfix">
          <h3>我的账户</h3>
        </div>
          <el-row>
            <el-col :span="4" class="common_border1">
              <div class="balanceLeft content-flex">
                <h3>证券资产</h3>
                <p><span class="balance_color">{{total.toFixed(2)}}</span> <span>元</span></p>
              </div>
            </el-col>
           
            <el-col :span="4" style="margin-top:25px;margin-left:20px;text-align: center;">
              <router-link to="/myaccount/capital">
                    <el-button type="danger" style="background-color: #D02E27;border:#D02E27;">充值</el-button>
                  </router-link>
                  <router-link :to="{path:'/myaccount/capital',query:{active:'withdraw'}}">
                    <el-button type="primary" style="background-color: #0D268D;border:#0D268D;">提现</el-button>
                  </router-link>
            </el-col>
            <el-col v-if="stablebaoStatus==1" :span="4" style="margin-top:10px;text-align: center;margin-left:15px;"  class="common_border1">
                  <el-button type="warning"  @click="moveOutState = true;" style="background-color: #ED7D31;border:#ED7D31">稳定币基金转入 </el-button>
            </el-col>
            <el-col :span="4" style="margin-top:10px;text-align: center;margin-left:20px;"  class="common_border1">
                  <el-button type="warning" id="signIn" @click="signIn" style="background-color: #3F7A21;border:#3F7A21">签到送现金 
                    <el-tooltip
                              class="item"
                              effect="dark"
                              :content=tooltipText
                              placement="top-start"
                              ><i class="el-icon-question white"></i></el-tooltip
                          >
                        </el-button>
            </el-col>
          </el-row>
        <div class="userContent" >
          <el-row>
            <el-col :span="4" class="common_border">
              <div class="balanceLeft content-flex">
                <h3>总账户&nbsp;<router-link to="/myaccount/account_info?active_tab=bill" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{cash.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
            <!-- <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <el-col :span="4" class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex ">
                <h3>时时宝&nbsp;<router-link to="/myaccount/timebao" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{timebao_accout.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
            <!-- <el-col :span="1" >
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <el-col :span="4" v-if="vipRewardTradeStatus == 1" class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex">
                <h3>VIP奖励&nbsp;<router-link to="/myaccount/vip_reward" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{user_vip_reward_balance.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
            <!-- <el-col :span="1" v-if="vipRewardTradeStatus == 1">
              <p class="balanceLeft content-flex contentAdd"></p>
            </el-col> -->
            
             <el-col :span="4" v-if="lifetime_reward_status == 1" class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex">
                <h3>终生奖励&nbsp;<router-link to="/myaccount/lifetime_reward" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{life_time_reward_balance.toFixed(2)}}</span> &nbsp;元</p>
              </div>
            </el-col>
            <!-- <el-col :span="1" v-if="lifetime_reward_status == 1">
              <p class="balanceLeft content-flex contentAdd"></p>
            </el-col> -->
           
            <el-col :span="4"  class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex">
                <h3>代金券&nbsp;<router-link to="/myaccount/account_info?active_tab=bill&log=vouchermanage_log" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{voucher_management.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
            <!-- <el-col :span="1" v-if="lifetime_reward_status == 0||vipRewardTradeStatus==0">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <el-col :span="4" v-if="lifetime_reward_status == 0||vipRewardTradeStatus==0" class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex">
                <h3>代理佣金&nbsp;<router-link to="/myaccount/agency" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{agent_account.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col> 
            <!-- <el-col :span="1" v-if="lifetime_reward_status == 0 && vipRewardTradeStatus==0">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <el-col :span="4" v-if="lifetime_reward_status == 0 && vipRewardTradeStatus==0" class="common_border" style="margin-left:20px;">
              <div class="balanceLeft content-flex">
                <h3>总保证金</h3>
                <p><span class="balance_color">{{bond.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:-20px;">             
            <el-col :span="4" class="common_border" v-if="lifetime_reward_status == 1 && vipRewardTradeStatus==1">
              <div class="balanceLeft content-flex " >
                <h3>代理佣金&nbsp;<router-link to="/myaccount/agency" class="text_blue_color">明细</router-link></h3>
                <p><span class="balance_color">{{agent_account.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col> 
            <!-- <el-col :span="1" v-if="lifetime_reward_status == 1 && vipRewardTradeStatus==1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <el-col :span="4" v-if="lifetime_reward_status == 1 ||  vipRewardTradeStatus==1" class="common_border" :style="marginStyle">
              <div class="balanceLeft content-flex ">
                <h3>总保证金</h3>
                <p><span class="balance_color">{{bond.toFixed(2)}}</span>&nbsp;元</p>
              </div>
            </el-col>
           
          </el-row>
          <!-- <el-divider></el-divider> -->
          <!-- <el-row> -->
            <!--<el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总配资金额</h5>
                <p>{{total_capital.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col>
            <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col>-->
            <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总证券市值</h5>
                <p>{{market.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col> -->
            <!-- <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总浮动盈亏</h5>
                <p>{{profit_loss.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col>
            <el-col :span="1">
              <p class="contentDetails content-flex contentAdd"></p>
            </el-col> -->
            <!-- <el-col :span="3">
              <div class="contentDetails content-flex">
                <h5>总冻结资金</h5>
                <p>{{frozen.toFixed(2)}} <span>元</span></p>
              </div>
            </el-col> -->
          <!-- </el-row> -->
        </div>
       <!-- <div class="userPerfect">
          <el-row>
            <el-col :span="8">
              <div class="perfect_content">
                <div class="perfect_title">
                  <p class="perfect_img">
                    <i class="el-icon-c-scale-to-original"></i>
                  </p>
                  <div>
                    <p>实名认证</p>
                    <p>实名认证</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>-->
      </el-card>
      <!--<div class="userInfo">
        <el-row>
          <el-col :span="6" >
            <div class="userLeft">
              <div class="userContent user-flex">
                <h2>资产总计</h2>
                <p class="red">{{total}}</p>
              </div>
              <div class="userContent user-flex">
                <div>
                  <router-link to="/myaccount/capital">
                    <el-button type="danger" >充值</el-button>
                  </router-link>
                  <router-link to="/myaccount/capital">
                    <el-button type="primary" >提现</el-button>
                  </router-link>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="4" :offset="1">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>可用资金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{cash}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总配资金额<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{total_capital}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>总冻结保证金</h3>
                <p class="red">{{bond}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总证券市值<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{market}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>代金券<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{voucher_management}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总浮动盈亏</h3>
                <p class="red">{{profit_loss}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="userRight">
              <div class="userContent user-flex">
                <h3>代理佣金<router-link to="/myaccount/detailed"><span class="red detail">[明细]</span></router-link></h3>
                <p class="red">{{agent_account}}</p>
              </div>
              <div class="userContent user-flex">
                <h3>总冻结资金</h3>
                <p class="red">{{frozen}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>-->
    </div>
   <!-- <div class="rechargeaumoudle">
      <div class="rehcarge2_current">
        &lt;!&ndash; <router-link to="/myaccount/rechange/quickpay">支付宝支付</router-link>
        <router-link to="/myaccount/rechange/wx">数字货币充值</router-link> &ndash;&gt;
        <router-link to="/myaccount/rechange/authentication" class="recharge2_border">支付宝支付</router-link>
        <router-link to="/myaccount/rechange/quickpay">快捷充值</router-link>
        &lt;!&ndash; <router-link to="/myaccount/rechange/netpay">网银支付</router-link> &ndash;&gt;
        &lt;!&ndash; <router-link to="/myaccount/rechange/sweep">网银支付</router-link>
        <router-link to="/myaccount/rechange/netpay2">扫码支付</router-link> &ndash;&gt;
        <router-link to="/myaccount/rechange/rechargelist">充值记录</router-link>
      </div>
      <div class="recharge2_content">
        <div class="recharge2_right">
          <div class="process">
            <table border="1" cellspacing="0" cellpadding="0" class="banK1_table1">
              <tr>
                <td class="text-ident">转账金额</td>
                <td height="80px">
                  <div class="span-tittle">
                    <span>人民币：</span>
                    <el-input
                      class="recharge-money"
                      v-model="inputMoney"
                      type="number"
                      placeholder="请输入充值人民币"
                    ></el-input>
                    <span style="color: #f83200;">*</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="1">支付宝充值</el-radio>
                </td>
                <td height="200px">
                  <img class="img-range" :src="zfbSrc">
                </td>
              </tr>
              &lt;!&ndash; <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="2">微信充值</el-radio>
                </td>
                <td height="200px">
                  <img class="img-range" :src="wxSrc">
                </td>
              </tr> &ndash;&gt;
              <tr>
                <td class="text-ident">
                  <el-radio v-model="type" label="3">银行充值</el-radio>
                </td>
                <td class="td-p" height="180px">
                  <p>姓名：{{name}}</p>
                  <p>银行名称：{{bank}}</p>
                  <p>银行卡号：{{card}}</p>
                  <p>开户行名称：{{address}}</p>
                </td>
              </tr>
              <tr>
                <td></td>
                <td height="60px">
                  <el-button
                    class="bank1_btn1"
                    type="danger"
                    plain
                    @click="pay"
                    :disabled="disabled"
                  >前往支付</el-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="recharge2_p11 bank1_p1">
            <span class="bank1_span1">温馨提示:</span>
            <p v-html="content"></p>
          </div>
        </div>
      </div>
    </div>-->
    <el-dialog id="couponContentPopup" v-if="couponPopupContent" :visible.sync="couponPopShow">
      <el-form ref="form" label-width="100px" >
        <el-form-item>
          <p style="text-align:center; font-size: 17px; display:none">首充礼品清单</p>
          <div v-html="couponContent" style="cursor:pointer;text-align: center">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="cancelCoupon()">关闭并本周不提醒
        </el-button>
        <el-button type="primary" class="button_blue_color" @click="goToCoupon()">前往好友现金券
        </el-button>
      </div>
    </el-dialog>


    <el-dialog id="realNameVerifiedPopup" :visible.sync="isRealNameVerified">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px;">您还没有实名</p>
          <p style="text-align:center; font-size: 17px;margin-top:10px">请实名激活<span>&nbsp;{{sys_give_voucher_amount}}&nbsp;</span>元礼金</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="cancel()">取消</el-button>
        <el-button type="primary" @click="real.realStatus = true">立即实名</el-button>
      </div>
    </el-dialog>
    <el-dialog id="firstTimeRechargePopup" :visible.sync="isFirstTimeRecharge" :width="'550px'"class="custom-dialog" @opened="popupButton">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px; display:none">首充礼品清单</p>
          <div v-html="before_recharge" ref="rechargeContent" class="dialog-content" style="padding: 20px;"></div>
        </el-form-item>
      </el-form>
    </el-dialog>
     <el-dialog id="firstTimeTradingPopup" :visible.sync="isFirstTimeTrading">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <p style="text-align:center; font-size: 17px; display:none">新会员交易红包清单</p>
           <div v-html="before_trading" style="cursor:pointer;" @click="goToTradingContent()">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button  @click="cancelTrade()">取消</el-button>
        <el-button  type="primary" @click="goToTrade()">立即配资交易</el-button>
      </div>
    </el-dialog>
    <el-dialog title="实名认证" :visible.sync="real.realStatus" width="25%" :close-on-click-modal="false">
      <el-form :model="real">
        <el-form-item>
          <el-input placeholder="请输入真实姓名" v-model="real.inputReal"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入身份证号" v-model="real.inputIdcard"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="real.realStatus = false">取 消</el-button>
        <el-button type="primary" @click="setReal">确 定</el-button>
      </div>
    </el-dialog>
    <!--stbale fun transfer-->
      <el-dialog class="stable_coinbao_popup" title="从稳定基金转出" :visible.sync="moveOutState">
      <el-form ref="form" label-width="100px" size="small">
        <el-form-item>
          <h4 slot="label">可转余额:</h4>
          <p>{{ stableCoinbaoBalance }} GCNY</p>
        </el-form-item>
        <el-form-item>
          <h4 slot="label">转出金额:</h4>
          <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="moveOutAmount" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="moveOutState = false">取消</el-button>
        <el-button type="primary" class="button_blue_color" @click="moveout">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import $ from "jquery";
import Rechargeheader from "./../components/rechargeheader";

export default {
  name: "Rechargehome",
  components: {
    Rechargeheader
  },
  data() {
    return {
      //配资保证金
      bond: 0,
      //账户余额
      cash: 0,
      //提现未批准总额
      frozen: 0,
      //持仓总市值
      market: 0,
      phone: "",
      //总市值+现金
      total: 0,
      time: "",
      //佣金总额
      agent_account:0,
      //代金卷总额
      voucher_management:0,
      //浮动盈亏
      profit_loss: 0,
      //定期宝
      finance:0,
      //余额宝
      holiday:0,
      timebao_accout:0,
      user_vip_reward_balance:0,
      vipRewardTradeStatus:0,
      isRealNameVerified: false,
      isFirstTimeRecharge: false,
      isFirstTimeTrading: false,
      sys_give_voucher_amount: "",
      before_recharge: "",
      before_trading: "",
      couponContent: "",
      couponPopShow: true,
      isRealNamePopShow: false,
      isRechargePopShow: false,
      isTradingPopShow: false,
      isFriendId : "",
      couponPopupContent: false,
      real:{
        inputReal:'',
        inputIdcard:'',
        realStatus:false
      },
      tooltipText: "",
      checkingDays: '',
      checkingCashAmount: '',
      checkingVoucherAmount: '',
      checkingrechargeAmount: '',
      life_time_reward_balance:0,
      lifetime_reward_status:0,
      clientIp:'',
      clientIpFetchUrl:'',
      moveOutState:false,
      stableCoinbaoBalance:0,
      moveOutAmount:null,
      stablebaoStatus:0,
    };
  },
  created() {
    this.$store.state.accountType = 1;
  },
  computed:{
    //总配资金额
    total_capital:function () {
      let that = this;
      return Number(that.market) + Number(that.profit_loss) + Number(that.frozen)
    },
    marginStyle() {
    if (this.lifetime_reward_status == 1 && this.vipRewardTradeStatus == 1) {
      return { marginLeft: '20px' }; 
    } else if (this.lifetime_reward_status == 1 || this.vipRewardTradeStatus == 1) {
      return { marginLeft: '0px' }; 
    } else {
      return { marginLeft: '20px' }; 
    }
  }
  },
  mounted: function() {
    this.getClientIpConfig();
    this.isRealNamePopShowM();
    this.isRechargePopShowM();
    this.isTradingPopShowM();
    this.getUserinfo();
    this.isFriendCoupon();
    this.couponPopup();
    this.getClientIP();
    this.getSysConfig();
    if(localStorage.getItem("couponStatus") == "false") {
      this.couponPopShow = false;
    }
    if(localStorage.getItem("couponStatus") == "true") {
      this.couponPopShow = true;
    }
  },
  methods: {
       getSysConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "stablebao_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.stablebaoStatus = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    //transfer money from stable funds to main account
     moveout(){
        let that = this;
        let money = that.moveOutAmount;
        that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "stable_coinbao_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.moveOutState = false;
                  that.moveOutAmount=null;
                  that.$message({
                    message: res.data.msg,
                    type: 'success',
                  });
                  that.getUserinfo();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(res.data.msg);
                }
              });
      },
    //get cleint ip url frm config
    getClientIpConfig() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "sysconfig",
            name: "client_ip_get_gateway",
          },
        })
        .then((ret) => {
          let resData = ret.data;
          if (resData.code === 1) {
            that.clientIpFetchUrl = resData.data;
          }
        });
    },
    //Recharge popup new UI change
    popupButton() {
      this.$nextTick(() => {
        const rechargeContent = this.$refs.rechargeContent;
        if (!rechargeContent) return;

        // Get all child nodes (including <p>, <div>, images)
        const originalContent = Array.from(rechargeContent.childNodes);

        // Find only the <p> elements for button positioning
        const elements = rechargeContent.querySelectorAll("p");
        if (elements.length < 2) return;

        const targetElement1 = elements[1]; 
        const targetElement2 = elements[2]; 

        rechargeContent.querySelectorAll("img").forEach((img) => {
          img.style.width = "20px";
          img.style.height = "20px";
          img.style.borderRadius = "50%";
          img.style.objectFit = "cover";
        });

        // Function to create a row where <p> and button stay in the same line
        const createRowContainer = (textElement, buttonElement) => {
          const row = document.createElement("div");
          row.style.display = "flex";
          row.style.justifyContent = "space-between";
          row.style.alignItems = "center";
          row.style.width = "100%";
          row.style.marginBottom = "5px";

          const textWrapper = document.createElement("div");
          textWrapper.style.flex = "1";
          textWrapper.style.textAlign = "left";
          textWrapper.appendChild(textElement);

          const buttonWrapper = document.createElement("div");
          buttonWrapper.style.flex = "0";
          buttonWrapper.style.marginLeft = "auto"; 
          buttonWrapper.appendChild(buttonElement);

          row.appendChild(textWrapper);
          row.appendChild(buttonWrapper);
          return row;
        };

        // Create "SignIN" button
        const signInButton = document.createElement("button");
        signInButton.textContent = "签到送现金";
        signInButton.className = "el-button el-button--primary el-button--mini";
        signInButton.style.height = "30px";
        signInButton.style.width = "80px";
        signInButton.style.fontSize = "12px";

        signInButton.addEventListener("click", (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.signIn();
        });

        // Create "Recharge" button
        const rechargeButton = document.createElement("button");
        rechargeButton.textContent = "立即充值";
        rechargeButton.className = "el-button el-button--primary el-button--mini";
        rechargeButton.style.height = "30px";
        rechargeButton.style.width = "80px";
        rechargeButton.style.fontSize = "12px";

        rechargeButton.addEventListener("click", (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.goToRecharge();
        });

        // Preserve all existing content (including non-<p> elements)
        rechargeContent.innerHTML = ""; 

        // Re-add all original content while modifying only <p> elements
        originalContent.forEach((element) => {
          if (element === targetElement1) {
            rechargeContent.appendChild(createRowContainer(targetElement1, signInButton));
          } else if (element === targetElement2) {
            rechargeContent.appendChild(createRowContainer(targetElement2, rechargeButton));
          } else {
            rechargeContent.appendChild(element); 
          }
        });
      });
    },

    setReal() {
      let that = this;
      if (that.real.inputReal == "") {
        that.$message.error("请输入真实姓名");
      } else if (that.real.inputIdcard == "") {
        that.$message.error("请输入身份证号");
      } else {
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "certification",
              token: sessionStorage.getItem("token"),
              name: that.real.inputReal,
              card: that.real.inputIdcard
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$message({
                message: res.data.msg,
                type: "success",
                duration: 1000,
                onClose:function () {
                  that.real.realStatus = false;
                  that.recharge.realStatus = true;
                }
              });
              that.isRealNameVerified = false;
              that.getUserinfo();
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    },
    // goToRechargeContent() {
    //   // this.$router.push({path:'/popcontent?activityid=recharge_popup_image'})
    //    this.$router.push({
    //         path:"/popcontent1?activityid=recharge_popup_image_pc"
    //       })
    //       //  this.$router.push({
    //       //   path:"/stockdetailed?symbol=sh000001"
    //       // })
    // },
    goToTradingContent() {
      // this.$router.push({path:'/popcontent?activityid=recharge_popup_image'})
       this.$router.push({
            path:"/popcontent1?activityid=trading_popup_image_pc"
          })
          //  this.$router.push({
          //   path:"/stockdetailed?symbol=sh000001"
          // })
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            let resData = res.data.data;
            that.bond = Number(resData.bond);
            that.cash = Number(resData.cash);
            that.frozen = Number(resData.frozen);
            that.market = Number(resData.market);
            that.phone = Number(resData.phone);
            that.vipRewardTradeStatus = resData.vipRewardTradeStatus;
            that.user_vip_reward_balance = resData.vipRewardTradeStatus==1?Number(resData.user_vip_reward_balance):0;
            that.lifetime_reward_status = resData.lifetime_reward;
            that.life_time_reward_balance = resData.lifetime_reward==1?Number(resData.lifetime_reward_balance):0;
            that.timebao_accout = Number(resData.timebao_accout);
            that.total = Number(resData.cash) + Number(resData.bond) + Number(resData.voucher_management) + Number(resData.agent_account)+ that.user_vip_reward_balance+ that.life_time_reward_balance+ Number(resData.timebao_accout);
            that.time = resData.time;
            that.agent_account = Number(resData.agent_account);
            that.voucher_management = Number(resData.voucher_management);
            that.profit_loss = Number(resData.profit_loss);
            that.finance = resData.finance;
            that.holiday = resData.holiday;
            that.tooltipText = resData.check_in_remainder;
            that.stableCoinbaoBalance=Number(resData.stable_coinbao_account);
            // that.checkingCashAmount = resData.sys_checkin_cash_amount;
            // that.checkingDays = resData.sys_checkin_days;
            // that.checkingVoucherAmount = resData.sys_checkinamount;
            // that.checkingrechargeAmount = resData.sys_checkin_recharge_amount;
            //   that.tooltipText = "充值 < " + that.checkingrechargeAmount + "，签到每日送 " + that.checkingVoucherAmount + "元代金券。"
            //                     + "充值 >= " + that.checkingrechargeAmount + ",签到每日送 " + that.checkingCashAmount + "元现金 [和"+ that.checkingVoucherAmount +"元代金券]，可签到"
            //                     + that.checkingDays + "次，即得" + parseInt(that.checkingCashAmount * that.checkingDays) + "元。"
            //                     + "已经签到" + that.checkingDays + "次，再次充值" + that.checkingrechargeAmount + "后可再次签到" + that.checkingDays + "次";
            
            if (res.data.data.real == ''){
              //show popup
              that.realNameConfig();
             if(that.isRealNamePopShow) {
                that.isRealNameVerified = true;
             }

              // that.$confirm('请完成实名后激活3999元礼金', '实名提醒', {
              //   confirmButtonText: '确定',
              //   cancelButtonText: '取消',
              //   type: 'warning'
              // }).then(() => {
              //   that.$router.push({path:'/myaccount/information'})
              // })
            }

            if(res.data.data.real){
              // that.isFirstTimeRecharge = true;
              //need to check is first time recharge
              that.isFirstRecharge();

              // if(res.data.data.cash == "0.00") {
              //     that.rechargeConfig();
              //     that.isFirstTimeRecharge = true;
              // } else {
              //     that.isFirstTimeRecharge = false;
              //     that.isFirstTrade();
              // }
            }

          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    isFriendCoupon() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "is_friend_coupon",
            token: sessionStorage.getItem("token"),
          }
        })
        .then(function(res) {
          if (res.data.code === 1) {
            that.isFriendId = res.data.data;

            var id = localStorage.getItem("friendCouponID");

            if(Number(id) !== Number(that.isFriendId.id)){
              sessionStorage.removeItem("couponCheck");
            }

            if(!(sessionStorage.getItem("couponCheck"))) {
              if (that.isFriendId.id) {
                if (id === null || Number(id) !== Number(that.isFriendId.id)) {
                  that.couponPopShow = true;
                  localStorage.setItem("friendCouponID", that.isFriendId.id);
                  localStorage.setItem("couponStatus", "true");
                  that.couponPopup();
                } else if (Number(id) === Number(that.isFriendId.id) && localStorage.getItem("couponStatus") === "true") {
                  that.couponPopShow = true;
                  that.couponPopup();
                } else if (Number(id) === Number(that.isFriendId.id) && localStorage.getItem("couponStatus") === "false") {
                  that.couponPopShow = false;
                }
              }
            }

            sessionStorage.setItem("couponCheck", "1");
            // if(localStorage.getItem("friendCouponID") !== that.isFriendId.id){
            //   localStorage.setItem("couponStatus", "true");
            // } else {
            //   localStorage.setItem("couponStatus", false);
            // }
            //   var status = localStorage.getItem("couponStatus");
            // if(status === true) {
            //   that.couponPopShow = true;
            //   localStorage.setItem("friendCouponID", that.isFriendId.id);
            //   that.couponPopup();
            // } else {
            //   that.couponPopShow = false;
            // }
          }
        });
    },

    couponPopup() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "coupon_web_popup",
            token: sessionStorage.getItem("token"),
            // name:"coupon"
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.couponContent = res.data.data;
            if(!that.couponContent) {
              that.couponPopShow = false;
              that.couponPopupContent = false;
            } else {
              that.couponPopupContent = true;
            }
            that.couponContent = that.couponContent.replace("http://wonder.apps/friend_coupon", "#/myaccount/friend_coupon");
            that.couponContent = that.couponContent.replace("http://wonder.apps/activity/", "#/stockguild?activityid=");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/11", "#/stockguild?activityid=11");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/17", "#/stockguild?activityid=17");
            // that.couponContent = that.couponContent.replace("http://wonder.apps/activity/15", "#/stockguild?activityid=15");
            // localStorage.setItem("couponStatus", true);
          } else {
            // that.isFirstTimeTrading = true;
            // localStorage.setItem("isFirstTimeRecharge", true);
          }
        });
    },

       realNameConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"sys_give_voucher_amount"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.sys_give_voucher_amount = res.data.data;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
         isRealNamePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_real_name_popup"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRealNamePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
        isRechargePopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isRechargePopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
         isTradingPopShowM() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"is_before_trading"
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                    that.isTradingPopShow = true;
                } else {
                  // that.isFirstTimeTrading = true;
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
        rechargeConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"before_recharge"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.before_recharge = res.data.data;
                } else {

                }
              });
        },
         tradeConfig() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "sysconfig",
                  token: sessionStorage.getItem("token"),
                  name:"before_trading"
                }
              })
              .then(function(res) {
                if (res.data.code == 1) {
                    that.before_trading = res.data.data;
                } else {

                }
              });
        },
        isFirstTrade() {
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "isfirst_deal",
                  token: sessionStorage.getItem("token"),
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                  that.isFirstTimeTrading = false;
                  localStorage.setItem("isFirstTimeRecharge", false);
                } else {
                  if(that.isTradingPopShow) {
                    that.tradeConfig();
                    that.isFirstTimeTrading = true;
                    localStorage.setItem("isFirstTimeRecharge", true);
                  }
                }
              });
        },

        isFirstRecharge() {
          //  if(res.data.data.cash == "0.00") {
          //         that.rechargeConfig();
          //         that.isFirstTimeRecharge = true;
          //     } else {
          //         that.isFirstTimeRecharge = false;
          //         that.isFirstTrade();
          //     }
          let that = this;
          that
            .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "isfirst_recharge",
                  token: sessionStorage.getItem("token"),
                }
              })
              .then(function(res) {
                if (res.data.data == 1) {
                  that.isFirstTimeRecharge = false;
                  that.isFirstTrade();
                  // localStorage.setItem("isFirstTimeRecharge", false);
                } else {
                  if(that.isRechargePopShow) {
                    that.rechargeConfig();
                    that.isFirstTimeRecharge = true;
                  }
                  // localStorage.setItem("isFirstTimeRecharge", true);
                }
              });
        },
    cancel() {
      this.isRealNameVerified = false;
    },
    cancelRecharge() {
      this.isFirstTimeRecharge = false;
    },
    cancelCoupon() {
      localStorage.setItem("couponStatus", "false");
      // var status = localStorage.getItem("couponStatus");
      // this.$store.commit('couponPopUpCheck',status);
      this.couponPopShow = false;
    },
    cancelTrade() {
      this.isFirstTimeTrading = false;
    },
    goToRealName() {
      // this.$router.push({path:'/myaccount/information'})

    },
    goToRecharge() {
      this.$router.push({path:'/myaccount/capital'})
    },
    goToCoupon() {
      this.$router.push({path:'/myaccount/friend_coupon'})
    },
    goToTrade() {
      this.$router.push({
            path:"/operate/operateday"
          })
    },
    //签到
    signIn(){
      let that = this;
      const button = document.querySelector('#signIn');
      button.disabled=true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "checkin",
            token: sessionStorage.getItem("token"),
            ip : this.clientIp,
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.$message({
              message: res.data.msg,
              type: 'success',
              onClose:function () {
                that.getUserinfo()
              }
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },
   
     //Fetch user IP
    getClientIP() {
    let that = this;
    $.ajax({
       url: "https://ifconfig.me/all.json",
       type: "GET",
      success: function (response) {
        console.log("IP:", response.ip_addr);
          that.clientIp = response.ip_addr;       
      },
      error: function (xhr, status, error) {
        var clientIpUrl=that.clientIpFetchUrl.split(',');
          var url=clientIpUrl[0];
              $.ajax({
          url: url, 
          type: "GET",
          success: function (response) {
            var a=that.clientIpFetchUrl.split(',')[1].trim();
              that.clientIp = response[a]; 
              console.log(that.clientIp);
          },
          error: function (xhr, status, error) {
            console.error("Error fetching IP:", error);
          }
        });
      }
    });
    },
  }
};
</script>
<style scoped>
  *{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
  #signIn:disabled{
    opacity: 0.3;
    cursor: not-allowed;
  }
  .userBalance{
    height: 60px;
    margin-bottom: 10px;
  }
  .userInfo{
    line-height: 30px;
    margin: 70px 0;
  }
  .detail{
    font-size: 14px;
    font-weight: normal;
  }
  .userLeft{
    height: 160px;
    border-right: 1px solid #DCDFE6;
  }
  .userRight{
    height: 160px;
  }
  .userContent {
    /*height: 60px;*/
    text-align: left;
  }
  .user-flex{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .content-flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .balanceLeft{
    height: 60px;
    line-height: 1.5;
    text-align: center;
  }
  .balanceLeft h4{
    font-weight: normal;
  }
  .balanceLeft p{
    color: #999;
  }
  .balance{
    font-size: 18px;
    color: #ff7100;
  }
  .contentDetails{
    line-height: 1.5;
    height: 60px;
  }
  .contentDetails h5{
    color: black;
    font-size: 14px;
    font-weight: 300;
  }
  .contentDetails p{
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .contentDetails span{
    color: #999;
  }
  .contentAdd{
    color: #999;
    font-size: 20px;
    font-weight: bold;
  }
  .perfect_content{

  }
  .perfect_img{
    width: 60px;
    height: 60px;
    background: #999;
    color: #FFFFFF;
    font-size: 60px;
    line-height: 60px;
  }
  .custom-dialog .el-dialog {
      padding: 20px; 
  }

  .dialog-content {
    padding-left: 8px !important; 
    padding-bottom: 0 !important;
    line-height: 55px !important;
  }
  .el-dialog__body {
    padding: 20px !important;
}
/deep/ .common_border{
  margin-bottom:20px !important;
}
/deep/ .common_border1{
  padding:15px !important;
}
</style>
<style>

#couponContentPopup .el-form-item{
  margin-bottom: 11px;
}
#couponContentPopup .el-dialog__body {
  padding: 0px;
}
#couponContentPopup .el-form-item__content {
  margin-left: 0px !important;
}
#couponContentPopup .el-dialog {
  width: 45%;
  margin-top: 17% !important;
}

#realNameVerifiedPopup .el-form-item{
  margin-bottom: 11px;
}
#realNameVerifiedPopup .el-dialog__body {
  padding: 0px;
}
#realNameVerifiedPopup .el-form-item__content {
  margin-left: 0px !important;
}
#realNameVerifiedPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
#firstTimeRechargePopup .el-form-item{
  margin-bottom: 11px;
}
#firstTimeRechargePopup .el-dialog__body {
  padding: 0px;
}
#firstTimeRechargePopup .el-form-item__content {
  margin-left: 0px !important;
}
#firstTimeRechargePopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
#firstTimeTradingPopup .el-form-item{
  margin-bottom: 11px;
  /*height: 140px;*/
}
#firstTimeTradingPopup .el-form {
 /* height: 155px;*/
}
#firstTimeTradingPopup .el-dialog__body {
  padding: 0px;
}
#firstTimeTradingPopup .el-form-item__content {
  margin-left: 0px !important;
}
#firstTimeTradingPopup .el-dialog {
  width: 25%;
  margin-top: 17% !important;
}
.common-bg{
border:1px solid #EBEEF5;
border-radius:20px !important;
margin:10px;
}
.balance_color{
  color: #ed7d31 !important;
  font-weight:normal !important;
}
.stable_coinbao_popup .el-dialog{
    width: 20% !important;
}

</style>




// WEBPACK FOOTER //
// src/components/rechargeau.vue